import { render, staticRenderFns } from "./DenunciaFormDenunciante.vue?vue&type=template&id=057b9784&scoped=true"
import script from "./DenunciaFormDenunciante.vue?vue&type=script&lang=js"
export * from "./DenunciaFormDenunciante.vue?vue&type=script&lang=js"
import style0 from "./DenunciaFormDenunciante.vue?vue&type=style&index=0&id=057b9784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057b9784",
  null
  
)

export default component.exports